<template>
	<Modal ref='modal' width='600px' 
		:title='(editing == null ? "Create" : "Edit")+" new "+(create == "sms" ? "SMS" : create)'
		:buttonYes='submitButtonText'
		:action='action'
		:yes='submitted'
		buttonsClass='lg:grid-cols-3 grid-cols-4 gap-3'
		buttonYesClass='col-span-2 lg:col-span-1'
		:buttonYesNameValue='["published_at", 1]'
	>
		<template #default="{ errors }">
			<input type='hidden' name='belongs_type' :value='model' />
			<input type='hidden' name='belongs_id' :value='modelId' />
			<input type='hidden' name='pinned' :value='pinned ? 1 : 0' />

			<Note v-if='create == "note"' :size='size' :editing='editing' />
			<Task v-if='create == "task" || create == "appointment"' :create='create' :size='size' :editing='editing' />
			<!-- <Appointment v-if='create == "appointment"' :size='size' :editing='editing' /> -->
			<SMS v-if='create == "sms"' :size='size' :communications='communications' :editing='editing' />
			<Deal v-if='create == "deal"' :size='size' :deal='editing' :errors='errors' />
			<!-- <Email v-if='create == "email"' :size='size' :emails='emails' /> -->
		</template>

		<template #buttons-right>
			<button class='h-12 font-medium text-13 underline text-purple-600 lg:w-2/2 w-fit'
				name='published_at' :value='null' v-if='canBeDrafted' :disabled='saving'>
				Save draft
			</button>

			<div class='flex justify-end'>
				<button class='h-12 w-4.5 flex items-center justify-end' @click='pinned = !pinned' type='button' v-if='canBePinned'>
					<IconPin class='h-4.5 w-4.5'
						:class='{
							"stroke-black": !pinned,
							"stroke-purple-500": pinned,
						}'/>
				</button>
			</div>
		</template>
	</Modal>
</template>

<script>
	import Errors from '~/models/errors.js';
	import Note from './create/note'
	import Task from './create/task'
	import SMS from './create/sms'
	import Email from './create/email'
	import Appointment from './create/appointment'
	import Deal from './create/deal'

	export default {
		props: {
			page: Object,
			visable: Boolean,
			create: {
				type: String,
				default: null
			},
			model: String,
			modelId: [Number, String],
			communications: {
				type: Array,
				default: []
			},
			editing: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				size: false,
				pinned: false
			}
		},

		methods: {
			open() {
				this.$refs.modal.open()
			},

			submitted() {
				this.page.call().updated()
				
				this.$emit('submitted')
			},

			close() {
				this.size = false;
			}
		},

		computed: {
			action() {
				if (this.editing != null) {
					return '/'+this.create+'/'+this.editing.id;
				}

				return '/'+this.create;
			},

			submitButtonText() {
				let t = '';
				let m = this.create;

				switch (this.create) {
					case 'note': t = 'Post'; break;
					case 'sms':
					case 'email': t = 'Send'; break;
					case 'task':
					case 'appointment':
					case 'deal': t = 'Create'; break;
				}

				if (this.create == 'sms') {
					return 'Send SMS message'
				}

				if (this.editing) {
					t = 'Update';
				}

				return t +' '+m
			},

			canBePinned() {
				return this.create != 'deal';
			},

			canBeDrafted() {
				return this.create != 'deal';
			}
		},

		components: {
			'Note': Note,
			'Task': Task,
			'SMS': SMS,
			'Email': Email,
			'Appointment': Appointment,
			'Deal': Deal,
		}
	}
</script>